export const ADD_STATISTIC_CATEGORY = "ADD_STATISTIC_CATEGORY";
export const SET_STATISTIC_CATEGORIES = "SET_STATISTIC_CATEGORIES";
export const UPDATE_STATISTIC_CATEGORY = "UPDATE_STATISTIC_CATEGORY";
export const DELETE_STATISTIC_CATEGORY = "DELETE_STATISTIC_CATEGORY";
